<div class="row mb-3">
  <div class="col-md-2"></div>
  <div class="col-12 col-md-8">
    <input
      type="text"
      class="w-80 ml-4"
      name="filterBlog"
      [(ngModel)]="search"
      placeholder="search..."
      (ngModelChange)="filterBlogs()">
    <button class="desktop-only"><i class="fa fa-search"></i></button>
  </div>
</div>

<div *ngIf="filteredBlogs.length == 0; else blogCard" class="card topic-card">
  <div class="card-body">
    <h5 class="text-center">No blogs found or posted yet!</h5>
  </div>
</div>

<ng-template #blogCard>
  <div class="row">
    <ng-container *ngFor="let blog of filteredBlogs">
      <div *ngIf="blog.posted == true" class="col-12 mb-3 media-card">
        <div class="card" (click)="navigateTo('/media/blog-posts/'+blog.id)">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-3">
                <div class="media-image">
                </div>
              </div>
              <div class="col-12 col-md-9">
                <div><b>{{ blog.title }}</b></div>
                <div><small>{{ blog.date | date }} | author: {{ blog.author }}</small></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
